"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OrthoContractCorrespondenceSetting_Factory = exports.Date_Factory = void 0;
var Date_Factory_1 = require("./Date_Factory");
Object.defineProperty(exports, "Date_Factory", { enumerable: true, get: function () { return Date_Factory_1.Date_Factory; } });
var CorrespondenceTemplate_1 = require("./CorrespondenceTemplate");
var OrthoContractCorrespondenceSetting_Factory = /** @class */ (function () {
    function OrthoContractCorrespondenceSetting_Factory() {
    }
    OrthoContractCorrespondenceSetting_Factory.CreateIncoming = function (model) {
        if (!model)
            return model;
        var result = {
            DefaultTemplate: CorrespondenceTemplate_1.CorrespondenceTemplate_Factory.CreateIncoming(model.DefaultTemplate),
            DefaultTemplateId: model.DefaultTemplateId,
            PaymentPlanTemplate: CorrespondenceTemplate_1.CorrespondenceTemplate_Factory.CreateIncoming(model.PaymentPlanTemplate),
            PaymentPlanTemplateId: model.PaymentPlanTemplateId,
            RecordCreated: Date_Factory_1.Date_Factory.CreateIncoming(model.RecordCreated),
            RecordId: model.RecordId,
            RecordLastUpdated: Date_Factory_1.Date_Factory.CreateIncoming(model.RecordLastUpdated),
            RecordStatus: model.RecordStatus,
        };
        return result;
    };
    OrthoContractCorrespondenceSetting_Factory.CreateOutgoing = function (model) {
        if (!model)
            return model;
        var result = {
            DefaultTemplate: CorrespondenceTemplate_1.CorrespondenceTemplate_Factory.CreateOutgoing(model.DefaultTemplate),
            DefaultTemplateId: model.DefaultTemplateId,
            PaymentPlanTemplate: CorrespondenceTemplate_1.CorrespondenceTemplate_Factory.CreateOutgoing(model.PaymentPlanTemplate),
            PaymentPlanTemplateId: model.PaymentPlanTemplateId,
            RecordCreated: Date_Factory_1.Date_Factory.CreateOutgoing(model.RecordCreated),
            RecordId: model.RecordId,
            RecordLastUpdated: Date_Factory_1.Date_Factory.CreateOutgoing(model.RecordLastUpdated),
            RecordStatus: model.RecordStatus,
        };
        return result;
    };
    return OrthoContractCorrespondenceSetting_Factory;
}());
exports.OrthoContractCorrespondenceSetting_Factory = OrthoContractCorrespondenceSetting_Factory;
